import { createContext, useContext } from "react";

interface DebugContextValue {
  accountId?: number;
}

export const DebugContext = createContext<DebugContextValue>({});

export const useDebugContext = () => useContext(DebugContext);
